export const ORTHOGONAL_STUB_PX = 32;
export const ORTHOGONAL_CORRIDOR_PX = 24;

const normalizeCoordinate = value => {
  const coordinate = Number(value);
  if (!Number.isFinite(coordinate)) return 0;

  return Number(coordinate.toFixed(2));
};
/**
 * Builds an SVG path made only of horizontal and vertical segments.
 * Forward connections use the midpoint between ports. Backward connections
 * leave both nodes through short stubs and use an external upper corridor.
 */
export const buildOrthogonalPath = (
  startX,
  startY,
  endX,
  endY,
  {
    stub = ORTHOGONAL_STUB_PX,
    corridor = ORTHOGONAL_CORRIDOR_PX,
  } = {}
) => {
  const sourceX = normalizeCoordinate(startX);
  const sourceY = normalizeCoordinate(startY);
  const targetX = normalizeCoordinate(endX);
  const targetY = normalizeCoordinate(endY);
  const safeStub = Math.max(0, normalizeCoordinate(stub));
  const safeCorridor = Math.max(0, normalizeCoordinate(corridor));

  if (targetX - sourceX >= safeStub * 2) {
    const middleX = normalizeCoordinate(sourceX + (targetX - sourceX) / 2);

    return `M ${sourceX} ${sourceY} H ${middleX} V ${targetY} H ${targetX}`;
  }

  const sourceExitX = normalizeCoordinate(sourceX + safeStub);
  const targetEntryX = normalizeCoordinate(targetX - safeStub);
  const corridorY = normalizeCoordinate(Math.min(sourceY, targetY) - safeCorridor);

  return [
    `M ${sourceX} ${sourceY}`,
    `H ${sourceExitX}`,
    `V ${corridorY}`,
    `H ${targetEntryX}`,
    `V ${targetY}`,
    `H ${targetX}`,
  ].join(" ");
};
